(() => {
  const root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('rr-motion-ready');
  const items = document.querySelectorAll('[data-rr-reveal]');
  if (!items.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rr-is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  items.forEach((item) => observer.observe(item));
})();

/* ROOMROOT mobile-fit kernel v2: viewport containment + native preset rail */
(() => {
  const styleId = 'rr-atmosphere-mobile-fit-v2';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media (max-width: 749px) {
      html, body {
        max-width: 100% !important;
        overflow-x: hidden !important;
      }

      .section-roomroot-atmosphere,
      .rr-atmosphere,
      .rr-atmosphere__content,
      .rr-atmosphere__modebar,
      .rr-atmosphere__copy,
      .rr-atmosphere__actions,
      .rr-atmosphere__signals {
        box-sizing: border-box !important;
        min-width: 0 !important;
        max-width: 100% !important;
      }

      .rr-atmosphere,
      .section-roomroot-atmosphere {
        width: 100% !important;
        max-width: 100vw !important;
      }

      .rr-atmosphere *,
      .rr-atmosphere *::before,
      .rr-atmosphere *::after {
        box-sizing: border-box !important;
      }

      .rr-atmosphere__content {
        width: 100% !important;
        margin-inline: auto !important;
        padding-left: max(1rem, env(safe-area-inset-left)) !important;
        padding-right: max(1rem, env(safe-area-inset-right)) !important;
      }

      .rr-atmosphere__modebar {
        display: block !important;
        width: 100% !important;
      }

      .rr-atmosphere__modes {
        display: flex !important;
        flex-wrap: nowrap !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: .25rem 3.75rem .8rem 0 !important;
        gap: .55rem !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch !important;
        overscroll-behavior-x: contain;
        touch-action: pan-x !important;
        scroll-snap-type: x proximity;
        scroll-padding-left: 0;
        scroll-padding-right: 3.75rem;
        scrollbar-width: none !important;
      }

      .rr-atmosphere__modes::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .rr-atmosphere__modes > .rr-atmosphere__mode {
        flex: 0 0 auto !important;
        width: auto !important;
        max-width: calc(100vw - 2rem) !important;
        white-space: nowrap !important;
        scroll-snap-align: start;
      }

      .rr-atmosphere__modes::after {
        content: '';
        display: block;
        flex: 0 0 2.75rem;
        width: 2.75rem;
        height: 1px;
        pointer-events: none;
      }

      .rr-atmosphere__status {
        display: inline-flex !important;
        max-width: 100% !important;
        margin-top: .7rem !important;
        white-space: normal !important;
      }

      .rr-atmosphere__title {
        max-width: 8.5ch !important;
        font-size: calc(clamp(3.35rem, 15.8vw, 5.6rem) * var(--rr-title-scale)) !important;
      }

      .rr-atmosphere__copy {
        width: 100% !important;
        max-width: 100% !important;
        overflow-wrap: anywhere !important;
        word-break: normal !important;
      }

      .rr-atmosphere__actions {
        display: grid !important;
        width: 100% !important;
      }

      .rr-atmosphere__button {
        width: 100% !important;
        max-width: 100% !important;
      }

      .rr-atmosphere__signals {
        display: grid !important;
        grid-template-columns: 1fr !important;
        width: 100% !important;
        gap: .3rem !important;
      }

      .rr-atmosphere__signals span {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        white-space: normal !important;
        overflow-wrap: anywhere !important;
      }

      .rr-atmosphere img,
      .rr-atmosphere video,
      .rr-atmosphere svg {
        max-width: 100% !important;
      }
    }
  `;
  document.head.appendChild(style);

  function centerModeButton(button, behavior) {
    if (!button || !window.matchMedia('(max-width: 749px)').matches) return;
    const rail = button.closest('.rr-atmosphere__modes');
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;

    const railRect = rail.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const desired = rail.scrollLeft + (buttonRect.left - railRect.left) - ((railRect.width - buttonRect.width) / 2);
    const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const left = Math.max(0, Math.min(desired, max));

    try {
      rail.scrollTo({ left, behavior: behavior || 'auto' });
    } catch (error) {
      rail.scrollLeft = left;
    }
  }

  function centerCurrentMode(behavior) {
    document.querySelectorAll('.rr-atmosphere__modes').forEach((rail) => {
      const active = rail.querySelector('.rr-atmosphere__mode.is-active, .rr-atmosphere__mode[aria-pressed="true"]');
      if (active) centerModeButton(active, behavior || 'auto');
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest ? event.target.closest('.rr-atmosphere__mode[data-roomroot-mode]') : null;
    if (!button) return;
    window.requestAnimationFrame(() => centerModeButton(button, 'smooth'));
  });

  const init = () => window.requestAnimationFrame(() => centerCurrentMode('auto'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => centerCurrentMode('auto'), 180);
  });
})();

/* ROOMROOT Field Console Premium v3: remove decorative plant + upgrade interaction language */
(() => {
  const styleId = 'rr-field-console-premium-v3';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .rr-field {
        isolation:isolate;
        border-color:color-mix(in srgb,var(--rr-accent) 24%,var(--rr-line)) !important;
        background:
          radial-gradient(circle at 88% 9%,color-mix(in srgb,var(--rr-accent-2) 16%,transparent),transparent 31%),
          radial-gradient(circle at 4% 92%,color-mix(in srgb,var(--rr-warm) 11%,transparent),transparent 32%),
          linear-gradient(135deg,color-mix(in srgb,var(--rr-surface) 92%,transparent),color-mix(in srgb,var(--rr-bg) 82%,transparent)) !important;
        box-shadow:0 2.3rem 7rem rgba(0,0,0,.26),inset 0 1px 0 color-mix(in srgb,var(--rr-text) 11%,transparent) !important;
      }
      .rr-field::after {
        content:'';
        position:absolute;
        inset:0;
        z-index:0;
        pointer-events:none;
        opacity:.23;
        background-image:
          linear-gradient(color-mix(in srgb,var(--rr-line) 38%,transparent) 1px,transparent 1px),
          linear-gradient(90deg,color-mix(in srgb,var(--rr-line) 38%,transparent) 1px,transparent 1px);
        background-size:44px 44px;
        mask-image:linear-gradient(90deg,transparent 0%,black 58%,black 100%);
      }
      .rr-field__header,.rr-field__main,.rr-field__qrgrid,.rr-field__footer {position:relative;z-index:2}
      .rr-field__header {
        background:linear-gradient(90deg,color-mix(in srgb,var(--rr-surface) 65%,transparent),transparent) !important;
        backdrop-filter:blur(16px) saturate(1.15);
      }
      .rr-field__edition {
        display:inline-flex;
        align-items:center;
        min-height:2rem;
        padding:.42rem .72rem;
        border:1px solid var(--rr-line);
        border-radius:999px;
        background:color-mix(in srgb,var(--rr-surface) 82%,transparent);
      }
      .rr-field__main {grid-template-columns:minmax(0,1.08fr) minmax(21rem,.92fr) !important}
      .rr-field__message {position:relative}
      .rr-field__eyebrow {
        display:inline-flex;
        width:max-content;
        max-width:100%;
        align-items:center;
        gap:.5rem;
        padding:.48rem .7rem;
        border:1px solid color-mix(in srgb,var(--rr-accent) 32%,var(--rr-line));
        border-radius:999px;
        background:color-mix(in srgb,var(--rr-accent) 7%,var(--rr-surface));
      }
      .rr-field__message h1 {
        text-shadow:0 .22em 1em rgba(0,0,0,.18);
      }
      .rr-field__message h1 em {
        background:linear-gradient(100deg,var(--rr-accent),color-mix(in srgb,var(--rr-accent-2) 72%,var(--rr-accent)) 56%,var(--rr-warm));
        -webkit-background-clip:text;
        background-clip:text;
        color:transparent !important;
      }
      .rr-field__lead {max-width:31rem !important}
      .rr-field__textlinks {
        display:grid !important;
        grid-template-columns:repeat(3,minmax(0,1fr));
        gap:.6rem !important;
        width:min(100%,42rem);
      }
      .rr-field__textlinks a {
        display:flex;
        align-items:center;
        justify-content:center;
        min-height:3.25rem;
        padding:.78rem .9rem !important;
        border:1px solid var(--rr-line) !important;
        border-radius:999px;
        background:linear-gradient(180deg,color-mix(in srgb,var(--rr-text) 7%,var(--rr-surface)),var(--rr-surface));
        box-shadow:inset 0 1px 0 color-mix(in srgb,var(--rr-text) 11%,transparent),0 .7rem 1.5rem rgba(0,0,0,.08);
        text-align:center;
        font-weight:700;
        letter-spacing:.025em;
        transition:transform .22s ease,border-color .22s ease,background .22s ease,box-shadow .22s ease !important;
      }
      .rr-field__textlinks a:hover {
        transform:translateY(-3px);
        color:var(--rr-text) !important;
        border-color:color-mix(in srgb,var(--rr-accent) 75%,var(--rr-line)) !important;
        background:linear-gradient(120deg,color-mix(in srgb,var(--rr-accent) 14%,var(--rr-surface)),color-mix(in srgb,var(--rr-accent-2) 10%,var(--rr-surface)));
        box-shadow:0 1rem 2.2rem color-mix(in srgb,var(--rr-accent) 11%,transparent),inset 0 1px 0 color-mix(in srgb,var(--rr-text) 14%,transparent);
      }
      .rr-field__textlinks a:active {transform:translateY(-1px) scale(.985)}

      .rr-field__botanical {
        min-height:34rem;
        padding:clamp(1.15rem,3vw,2.5rem) !important;
        border-left:1px solid var(--rr-line) !important;
        background:
          radial-gradient(circle at 50% 42%,color-mix(in srgb,var(--rr-accent) 10%,transparent),transparent 34%),
          radial-gradient(circle at 70% 22%,color-mix(in srgb,var(--rr-accent-2) 16%,transparent),transparent 30%),
          linear-gradient(155deg,color-mix(in srgb,var(--rr-bg) 22%,transparent),color-mix(in srgb,var(--rr-surface) 78%,transparent)) !important;
      }
      .rr-field__botanical > svg,.rr-field__botanical > .rr-field__orbit {display:none !important}
      .rr-field-console {
        position:relative;
        width:min(100%,31rem);
        border:1px solid color-mix(in srgb,var(--rr-accent) 30%,var(--rr-line));
        border-radius:1.75rem;
        overflow:hidden;
        background:
          linear-gradient(180deg,color-mix(in srgb,var(--rr-text) 5%,transparent),transparent 22%),
          color-mix(in srgb,var(--rr-bg) 50%,var(--rr-surface));
        box-shadow:0 2rem 4rem rgba(0,0,0,.2),inset 0 1px 0 color-mix(in srgb,var(--rr-text) 12%,transparent),0 0 0 1px color-mix(in srgb,var(--rr-accent) 4%,transparent);
        backdrop-filter:blur(22px) saturate(1.2);
      }
      .rr-fc__top {
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:1rem;
        padding:1rem 1.1rem;
        border-bottom:1px solid var(--rr-line);
        color:var(--rr-muted);
        font-size:.58rem;
        letter-spacing:.17em;
        text-transform:uppercase;
      }
      .rr-fc__top span {display:flex;align-items:center;gap:.45rem;color:var(--rr-accent);font-weight:800}
      .rr-fc__top span::before {content:'';width:.48rem;height:.48rem;border-radius:50%;background:var(--rr-accent);box-shadow:0 0 1rem var(--rr-accent)}
      .rr-fc__top b {font-weight:600;color:var(--rr-muted)}
      .rr-fc__map {
        position:relative;
        width:calc(100% - 2rem);
        aspect-ratio:1;
        margin:1rem;
        overflow:hidden;
        border:1px solid var(--rr-line);
        border-radius:1.35rem;
        background:
          radial-gradient(circle at center,color-mix(in srgb,var(--rr-accent) 14%,transparent) 0 2px,transparent 3px),
          radial-gradient(circle at center,transparent 0 39%,color-mix(in srgb,var(--rr-line) 35%,transparent) 39.2% 39.6%,transparent 40%),
          radial-gradient(circle at center,transparent 0 19%,color-mix(in srgb,var(--rr-line) 25%,transparent) 19.2% 19.6%,transparent 20%),
          linear-gradient(color-mix(in srgb,var(--rr-line) 18%,transparent) 1px,transparent 1px),
          linear-gradient(90deg,color-mix(in srgb,var(--rr-line) 18%,transparent) 1px,transparent 1px),
          radial-gradient(circle at center,color-mix(in srgb,var(--rr-accent-2) 11%,transparent),transparent 58%);
        background-size:auto,auto,auto,24px 24px,24px 24px,auto;
      }
      .rr-fc__map::after {
        content:'';
        position:absolute;
        left:50%;top:50%;
        width:45%;height:1px;
        transform-origin:left center;
        background:linear-gradient(90deg,color-mix(in srgb,var(--rr-accent) 72%,transparent),transparent);
        box-shadow:0 0 1rem color-mix(in srgb,var(--rr-accent) 26%,transparent);
        animation:rrConsoleSweep 7s linear infinite;
      }
      .rr-fc__ring {position:absolute;left:50%;top:50%;border-radius:50%;pointer-events:none}
      .rr-fc__ring--one {width:70%;height:70%;border:1px dashed color-mix(in srgb,var(--rr-accent) 47%,transparent);transform:translate(-50%,-50%);animation:rrConsoleSpin 24s linear infinite}
      .rr-fc__ring--two {width:48%;height:48%;border:1px solid color-mix(in srgb,var(--rr-accent-2) 36%,transparent);transform:translate(-50%,-50%);box-shadow:0 0 2rem color-mix(in srgb,var(--rr-accent-2) 7%,transparent)}
      .rr-fc__axis {position:absolute;background:linear-gradient(90deg,transparent,color-mix(in srgb,var(--rr-line) 65%,transparent),transparent);opacity:.8}
      .rr-fc__axis--x {left:7%;right:7%;top:50%;height:1px}
      .rr-fc__axis--y {top:7%;bottom:7%;left:50%;width:1px;background:linear-gradient(180deg,transparent,color-mix(in srgb,var(--rr-line) 65%,transparent),transparent)}
      .rr-fc__core {
        position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);
        width:7rem;height:7rem;border-radius:50%;
        display:grid;place-content:center;text-align:center;
        border:1px solid color-mix(in srgb,var(--rr-accent) 60%,var(--rr-line));
        background:radial-gradient(circle,color-mix(in srgb,var(--rr-accent) 18%,var(--rr-surface)),var(--rr-surface) 64%);
        box-shadow:0 0 0 .55rem color-mix(in srgb,var(--rr-accent) 3%,transparent),0 0 2.6rem color-mix(in srgb,var(--rr-accent) 17%,transparent),inset 0 1px 0 color-mix(in srgb,var(--rr-text) 14%,transparent);
      }
      .rr-fc__core small {font-size:.52rem;letter-spacing:.18em;color:var(--rr-muted)}
      .rr-fc__core strong {margin-top:.25rem;font-family:var(--rr-display-font);font-size:1.05rem;font-weight:500;color:var(--rr-text)}
      .rr-fc__node {position:absolute;width:.78rem;height:.78rem;border:2px solid var(--rr-bg);border-radius:50%;background:var(--rr-accent);box-shadow:0 0 0 .28rem color-mix(in srgb,var(--rr-accent) 10%,transparent),0 0 1.2rem color-mix(in srgb,var(--rr-accent) 50%,transparent)}
      .rr-fc__node--a {left:22%;top:28%}.rr-fc__node--b {right:19%;top:37%;background:var(--rr-accent-2);box-shadow:0 0 0 .28rem color-mix(in srgb,var(--rr-accent-2) 10%,transparent),0 0 1.2rem color-mix(in srgb,var(--rr-accent-2) 50%,transparent)}.rr-fc__node--c {left:34%;bottom:18%;background:var(--rr-warm);box-shadow:0 0 0 .28rem color-mix(in srgb,var(--rr-warm) 10%,transparent),0 0 1.2rem color-mix(in srgb,var(--rr-warm) 50%,transparent)}.rr-fc__node--d {right:31%;bottom:29%}
      .rr-fc__layers {display:grid;grid-template-columns:1fr 1fr;gap:.55rem;padding:0 1rem 1rem}
      .rr-fc__layers span {
        display:grid;
        grid-template-columns:auto 1fr auto;
        align-items:center;
        gap:.55rem;
        min-height:3.15rem;
        padding:.68rem .75rem;
        border:1px solid var(--rr-line);
        border-radius:.95rem;
        background:color-mix(in srgb,var(--rr-surface) 86%,transparent);
      }
      .rr-fc__layers i {width:.55rem;height:.55rem;border-radius:50%;background:var(--rr-accent);box-shadow:0 0 .9rem color-mix(in srgb,var(--rr-accent) 58%,transparent)}
      .rr-fc__layers span:nth-child(2) i {background:var(--rr-accent-2)}
      .rr-fc__layers span:nth-child(3) i {background:var(--rr-warm)}
      .rr-fc__layers span:nth-child(4) i {background:var(--rr-text)}
      .rr-fc__layers b {font-size:.62rem;letter-spacing:.12em;color:var(--rr-text)}
      .rr-fc__layers small {font-size:.54rem;letter-spacing:.08em;text-transform:uppercase;color:var(--rr-muted)}
      .rr-fc__foot {display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:.8rem 1rem 1rem;color:var(--rr-muted);font-size:.68rem;line-height:1.35}
      .rr-fc__foot b {font-size:1rem;color:var(--rr-accent)}

      .rr-field__qrgrid {gap:.7rem;padding:.7rem;background:color-mix(in srgb,var(--rr-bg) 23%,transparent) !important}
      .rr-qr {
        border:1px solid var(--rr-line) !important;
        border-radius:1.25rem;
        background:linear-gradient(145deg,color-mix(in srgb,var(--rr-text) 5%,var(--rr-surface)),var(--rr-surface)) !important;
        box-shadow:inset 0 1px 0 color-mix(in srgb,var(--rr-text) 10%,transparent),0 .8rem 1.8rem rgba(0,0,0,.08);
        transition:transform .24s ease,border-color .24s ease,box-shadow .24s ease,background .24s ease !important;
      }
      .rr-qr + .rr-qr {border-left:1px solid var(--rr-line) !important}
      .rr-qr:hover {transform:translateY(-4px);border-color:color-mix(in srgb,var(--rr-accent) 70%,var(--rr-line)) !important;box-shadow:0 1.2rem 2.8rem rgba(0,0,0,.14),0 0 2rem color-mix(in srgb,var(--rr-accent) 8%,transparent)}
      .rr-qr:active {transform:translateY(-1px) scale(.99)}
      .rr-qr__image {border:1px solid color-mix(in srgb,var(--rr-line) 70%,transparent);box-shadow:0 .8rem 1.8rem rgba(0,0,0,.18) !important}
      .rr-qr > b {display:grid;place-items:center;width:2.4rem;height:2.4rem;border:1px solid var(--rr-line);border-radius:50%;background:var(--rr-surface)}

      .rr-wholesale-bridge__grid a {
        position:relative;
        overflow:hidden;
        border-radius:1.4rem !important;
        background:
          radial-gradient(circle at 90% 6%,color-mix(in srgb,var(--rr-accent) 12%,transparent),transparent 35%),
          linear-gradient(145deg,color-mix(in srgb,var(--rr-text) 4%,var(--rr-surface)),var(--rr-surface)) !important;
        box-shadow:inset 0 1px 0 color-mix(in srgb,var(--rr-text) 9%,transparent),0 .8rem 2rem rgba(0,0,0,.08);
        transition:transform .24s ease,border-color .24s ease,box-shadow .24s ease !important;
      }
      .rr-wholesale-bridge__grid a::after {content:'↗';position:absolute;right:1rem;top:1rem;width:2.2rem;height:2.2rem;display:grid;place-items:center;border:1px solid var(--rr-line);border-radius:50%;color:var(--rr-accent);background:color-mix(in srgb,var(--rr-surface) 88%,transparent)}
      .rr-wholesale-bridge__grid a:hover {transform:translateY(-5px) !important;border-color:color-mix(in srgb,var(--rr-accent) 72%,var(--rr-line)) !important;box-shadow:0 1.4rem 3rem rgba(0,0,0,.13),0 0 2rem color-mix(in srgb,var(--rr-accent) 8%,transparent)}
      .rr-wholesale-bridge__grid span {display:grid;place-items:center;width:2.1rem;height:2.1rem;border-radius:999px;border:1px solid var(--rr-line);background:color-mix(in srgb,var(--rr-accent) 7%,var(--rr-surface))}
      .rr-wholesale-bridge__actionbar {padding:.75rem .8rem .75rem 1.15rem !important;border-radius:999px !important;background:color-mix(in srgb,var(--rr-surface) 78%,transparent)}
      .rr-wholesale-bridge__actionbar a {
        display:inline-flex;
        align-items:center;
        justify-content:center;
        min-height:3.25rem;
        padding:.78rem 1.15rem;
        border:1px solid color-mix(in srgb,var(--rr-accent) 60%,var(--rr-line));
        border-radius:999px;
        background:linear-gradient(115deg,var(--rr-accent),color-mix(in srgb,var(--rr-accent-2) 52%,var(--rr-accent)));
        color:#07140f !important;
        box-shadow:0 .9rem 2.2rem color-mix(in srgb,var(--rr-accent) 16%,transparent),inset 0 1px 0 rgba(255,255,255,.35);
        transition:transform .22s ease,box-shadow .22s ease,filter .22s ease;
      }
      .rr-wholesale-bridge__actionbar a:hover {transform:translateY(-2px);filter:saturate(1.08) brightness(1.03);box-shadow:0 1.1rem 2.6rem color-mix(in srgb,var(--rr-accent) 22%,transparent)}

      .rr-atmosphere__mode {
        min-height:2.75rem !important;
        padding:.68rem 1rem !important;
        border-color:color-mix(in srgb,var(--rr-text) 13%,var(--rr-line)) !important;
        background:linear-gradient(180deg,color-mix(in srgb,var(--rr-text) 6%,var(--rr-surface)),var(--rr-surface)) !important;
        box-shadow:inset 0 1px 0 color-mix(in srgb,var(--rr-text) 10%,transparent),0 .45rem 1.1rem rgba(0,0,0,.07);
      }
      .rr-atmosphere__mode:hover {border-color:color-mix(in srgb,var(--rr-accent) 70%,var(--rr-line)) !important;color:var(--rr-text) !important;background:color-mix(in srgb,var(--rr-accent) 9%,var(--rr-surface)) !important}
      .rr-atmosphere__mode.is-active {
        color:#07140f !important;
        border-color:color-mix(in srgb,var(--rr-accent) 72%,var(--rr-accent-2)) !important;
        background:linear-gradient(110deg,var(--rr-accent),color-mix(in srgb,var(--rr-accent-2) 48%,var(--rr-accent))) !important;
        box-shadow:0 .8rem 2rem color-mix(in srgb,var(--rr-accent) 18%,transparent),inset 0 1px 0 rgba(255,255,255,.4);
      }

      .rrsf__build,.rr2-btn,.rrhp__primary,.rr-kit__cta,.rr-bundle__cta {
        min-height:3.35rem !important;
        border-radius:999px !important;
        border:1px solid color-mix(in srgb,var(--rr-accent) 58%,var(--rr-line)) !important;
        background:linear-gradient(115deg,var(--rr-accent),color-mix(in srgb,var(--rr-accent-2) 50%,var(--rr-accent))) !important;
        color:#07140f !important;
        box-shadow:0 .9rem 2.4rem color-mix(in srgb,var(--rr-accent) 14%,transparent),inset 0 1px 0 rgba(255,255,255,.32) !important;
        transition:transform .22s ease,box-shadow .22s ease,filter .22s ease !important;
      }
      .rrsf__build:hover,.rr2-btn:hover,.rrhp__primary:hover,.rr-kit__cta:hover,.rr-bundle__cta:hover {transform:translateY(-3px);filter:saturate(1.08);box-shadow:0 1.15rem 2.8rem color-mix(in srgb,var(--rr-accent) 22%,transparent),inset 0 1px 0 rgba(255,255,255,.38) !important}
      .rrhp__secondary {min-height:3.35rem !important;border-radius:999px !important;border:1px solid var(--rr-line) !important;background:linear-gradient(180deg,color-mix(in srgb,var(--rr-text) 6%,var(--rr-surface)),var(--rr-surface)) !important;color:var(--rr-text) !important;box-shadow:inset 0 1px 0 color-mix(in srgb,var(--rr-text) 10%,transparent) !important}

      .rr-field__textlinks a:focus-visible,.rr-qr:focus-visible,.rr-wholesale-bridge a:focus-visible,.rr-atmosphere__mode:focus-visible,.rrsf__build:focus-visible,.rr2-btn:focus-visible,.rrhp__primary:focus-visible,.rrhp__secondary:focus-visible,.rr-kit__cta:focus-visible,.rr-bundle__cta:focus-visible {outline:2px solid var(--rr-accent) !important;outline-offset:4px !important}

      @keyframes rrConsoleSpin {to{transform:translate(-50%,-50%) rotate(360deg)}}
      @keyframes rrConsoleSweep {to{transform:rotate(360deg)}}

      @media(max-width:980px) {
        .rr-field__main {grid-template-columns:1fr !important}
        .rr-field__botanical {min-height:28rem;border-left:0 !important;border-top:1px solid var(--rr-line)}
        .rr-field-console {width:min(100%,34rem)}
      }
      @media(max-width:749px) {
        .rr-field__message {padding:1.6rem 1rem 1.25rem !important}
        .rr-field__textlinks {grid-template-columns:1fr !important;gap:.5rem !important}
        .rr-field__textlinks a {min-height:3.15rem}
        .rr-field__botanical {min-height:0 !important;padding:1rem !important}
        .rr-field-console {width:100%;border-radius:1.35rem}
        .rr-fc__map {width:calc(100% - 1.5rem);margin:.75rem;max-height:none}
        .rr-fc__layers {padding:0 .75rem .75rem;gap:.45rem}
        .rr-fc__layers span {min-height:2.8rem;padding:.58rem .62rem}
        .rr-field__qrgrid {grid-template-columns:1fr !important;gap:.6rem;padding:.6rem !important}
        .rr-qr + .rr-qr {border-left:1px solid var(--rr-line) !important;border-top:1px solid var(--rr-line) !important}
        .rr-wholesale-bridge__actionbar {border-radius:1.25rem !important;padding:1rem !important}
        .rr-wholesale-bridge__actionbar a {width:100%}
      }
      @media(max-width:390px) {
        .rr-fc__layers {grid-template-columns:1fr}
        .rr-field__edition {display:none}
      }
      @media(prefers-reduced-motion:reduce) {
        .rr-fc__ring--one,.rr-fc__map::after {animation:none !important}
        .rr-field__textlinks a,.rr-qr,.rr-wholesale-bridge__grid a,.rr-wholesale-bridge__actionbar a,.rr-atmosphere__mode,.rrsf__build,.rr2-btn,.rrhp__primary,.rrhp__secondary,.rr-kit__cta,.rr-bundle__cta {transition:none !important}
      }
    `;
    document.head.appendChild(style);
  }

  function mountFieldConsole(container) {
    if (!container || container.dataset.rrFieldConsoleMounted === 'true') return;
    container.dataset.rrFieldConsoleMounted = 'true';
    container.innerHTML = `
      <div class="rr-field-console">
        <div class="rr-fc__top"><span>System map</span><b>ROOMROOT / FIELD 01</b></div>
        <div class="rr-fc__map">
          <span class="rr-fc__ring rr-fc__ring--one"></span>
          <span class="rr-fc__ring rr-fc__ring--two"></span>
          <span class="rr-fc__axis rr-fc__axis--x"></span>
          <span class="rr-fc__axis rr-fc__axis--y"></span>
          <span class="rr-fc__node rr-fc__node--a"></span>
          <span class="rr-fc__node rr-fc__node--b"></span>
          <span class="rr-fc__node rr-fc__node--c"></span>
          <span class="rr-fc__node rr-fc__node--d"></span>
          <div class="rr-fc__core"><small>ROOM</small><strong>SYSTEM</strong></div>
        </div>
        <div class="rr-fc__layers">
          <span><i></i><b>LIGHT</b><small>layer</small></span>
          <span><i></i><b>WATER</b><small>layer</small></span>
          <span><i></i><b>SUPPORT</b><small>layer</small></span>
          <span><i></i><b>SPACE</b><small>layer</small></span>
        </div>
        <div class="rr-fc__foot"><span>Map the room. Choose the system. Tune the care.</span><b>↗</b></div>
      </div>`;
  }

  function initFieldConsole(root) {
    (root || document).querySelectorAll('.rr-field__botanical').forEach(mountFieldConsole);
  }

  const init = () => initFieldConsole(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();

  document.addEventListener('shopify:section:load', (event) => initFieldConsole(event.target));
})();
